import * as React from "react";
import styled from "@emotion/styled";
import {
  Collapse,
  Navbar,
  NavbarToggler,
  NavbarBrand,
  Nav,
  NavItem,
  NavLink,
  Button
} from "reactstrap";

// Themes
import { Colors } from "../../Themes";
import "./index.css";

const LogoText = styled.div`
  font-family: "PB", sans-serif;
  font-size: 2.55em;
  color: ${Colors.cmmsBlue};
  text-align: center;
`;

const btnStyling = {
  width: "180px"
};

interface IState {
  isOpen: boolean;
}

export default class FrontEndNav extends React.Component<{}, IState> {
  state = {
    isOpen: false
  };

  toggle() {
    this.setState({
      isOpen: !this.state.isOpen
    });
  }

  render() {
    return (
      <div className="frontend-nav">
        <Navbar expand="md">
          <NavbarBrand href="/">
            <LogoText>maintain.</LogoText>
          </NavbarBrand>
          <NavbarToggler onClick={this.toggle} />
          <Collapse isOpen={this.state.isOpen} navbar={true}>
            <Nav className="ml-auto" navbar={true}>
              <NavItem>
                <NavLink href="/sign-in">
                  <Button style={btnStyling} className="secondary-btn">
                    Login
                  </Button>
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink href="/sign-up">
                  <Button style={btnStyling}>Get Started</Button>
                </NavLink>
              </NavItem>
            </Nav>
          </Collapse>
        </Navbar>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/Components/FrontendNav/index.tsx